import {
  globalsSelector,
  systemSelector,
} from '@Utils/plarium/edgets-common/lib/configModule/edgeConfigModule';
import { userSpecificSelector } from '@Utils/plarium/edgets-common/lib/configModule/edgeUserSpecificModule';
import { createSelector } from 'reselect';
import { locales } from '../locales';

const analyticsSelector = (state: any) => (globalsSelector(state) as any).analytics;

export const integrationDataSelector = createSelector(
  [systemSelector, analyticsSelector, userSpecificSelector],
  getIntegrationData(locales.English.id),
);

interface IntegrationData {
  apiUrl: string;
  area: string;
  cluster: string;
  game: string;
  network: string;
  locale: string;
  tracker: string;
  query: string;
  referrer: string;
  lp: string;
  gu: string;
}

function getIntegrationData(defaultLocale: number) {
  return (system: any, analytics: any, userSpecific: any): IntegrationData => ({
    apiUrl: system.apiUrl || '/services/api/',
    area: analytics.area || 'totaldomination',
    cluster: analytics.cluster || 0,
    game: analytics.game || 0,
    network: analytics.network || 0,
    locale: analytics.locale || defaultLocale,
    tracker: analytics.tracker || false,
    query: userSpecific.query || '',
    referrer: userSpecific.referrer || '',
    lp: userSpecific.registeredUrl || userSpecific.lp || '',
    gu: userSpecific.gu || '',
  });
}
